export const deviceInsectTranslatePaths = {
  title: 'device_data.insects.title',
  select_insects: 'device_data.insects.select_insects',
  select_update_insect_name: 'device_data.insects.select_update_insect_name',
  detected_first_time: 'device_data.insects.detected_first_time',
};
